export const SOCIAL_CHANNELS = [
  { key: 'YouTube', label: 'YouTube', approvedKey: 'YouTubeApproved', allowedHosts: ['youtube.com', 'youtu.be'] },
  { key: 'WhatsApp', label: 'WhatsApp', approvedKey: 'WhatsAppApproved', allowedHosts: ['whatsapp.com', 'wa.me'] },
  { key: 'Instagram', label: 'Instagram', approvedKey: 'InstagramApproved', allowedHosts: ['instagram.com'] },
  { key: 'Facebook', label: 'Facebook', approvedKey: 'FacebookApproved', allowedHosts: ['facebook.com', 'fb.com', 'fb.me'] },
  { key: 'Telegram', label: 'Telegram', approvedKey: 'TelegramApproved', allowedHosts: ['t.me', 'telegram.me'] },
] as const;

export type SocialChannelKey = typeof SOCIAL_CHANNELS[number]['key'];
export type SocialLinkRecord = Record<string, unknown> & { IsPublished?: boolean };

export function isAllowedSocialUrl(channel: SocialChannelKey, value: unknown): value is string {
  if (typeof value !== 'string' || !value.trim()) return false;
  try {
    const url = new URL(value.trim());
    if (url.protocol !== 'https:' || url.username || url.password) return false;
    const config = SOCIAL_CHANNELS.find((item) => item.key === channel);
    return Boolean(config?.allowedHosts.some((host) => url.hostname.toLowerCase() === host || url.hostname.toLowerCase().endsWith(`.${host}`)));
  } catch {
    return false;
  }
}

export function approvedSocialLinks(record?: SocialLinkRecord) {
  if (!record?.IsPublished) return [];
  return SOCIAL_CHANNELS.flatMap((channel) => {
    const url = record[channel.key];
    return record[channel.approvedKey] === true && isAllowedSocialUrl(channel.key, url)
      ? [{ key: channel.key, label: channel.label, url: url.trim() }]
      : [];
  });
}
